<template>
  <b-modal v-model="modalShow" centered hide-header hide-footer no-close-on-backdrop>
    <div class="d-block text-center modal-container">
      <div class="content-subject">{{ $t('error.failedToProcess') }}</div>
      <div class="content-desc">{{ $t('selfcheck.selfcheckWaitMomentApology') }}</div>
      <div class="button-wrap">
        <so-button class="so-button call-button" @click="handleCallStaff">
          {{ $t('selfcheck.calling') }}
        </so-button>
        <so-button class="so-button close-button" @click="handleClose">
          {{ $t('common.close') }}
        </so-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as api from '@/api'
import SoButton from '@/components/common/SoButton'

export default {
  components: {
    SoButton,
  },
  computed: {
    ...mapGetters({
      isShowingSelfcheckInitErrorModal: 'modal/isShowingSelfcheckInitErrorModal',
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
    }),
    modalShow: {
      get() {
        return this.isShowingSelfcheckInitErrorModal
      },
      set(value) {
        this.setShowingSelfcheckInitErrorModal(value)
      },
    },
  },
  methods: {
    ...mapActions({
      setShowingSelfcheckInitErrorModal: 'modal/setShowingSelfcheckInitErrorModal',
      setShowingCallingStaffModal: 'modal/setShowingCallingStaffModal',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
    }),
    handleClose() {
      this.setShowingSelfcheckInitErrorModal(false)
    },
    async handleCallStaff() {
      try {
        await api.callStaff(this.shopId, this.seatNo)
        this.setShowingSelfcheckInitErrorModal(false)
        this.setShowingCallingStaffModal(true)
      } catch (error) {
        this.setShowingSimpleErrorModal(true)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
  padding-bottom: 8px;
}
.content {
  color: #222222;
  &-subject {
    font-size: 18px;
    font-weight: bold;
  }
  &-desc {
    padding: 20px 0;
    text-align: left;
    font-size: 14px;
  }
}
.button-wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;

  & .so-button {
    width: 48%;
  }
}
.content-desc {
  white-space: pre-wrap;
}
</style>
